<div
  class="flex min-h-screen flex-col items-center justify-center bg-gray-50 p-4"
>
  <div class="w-full max-w-md rounded-2xl bg-white p-8 text-center shadow-lg">
    <div class="mb-6">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="mx-auto h-20 w-20 text-orange-500"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z"
        ></path>
      </svg>
    </div>

    <h1 class="mb-3 text-2xl font-bold text-gray-800">Experiência completa</h1>

    <p class="mb-6 text-gray-600">
      Para acessar todos os recursos e funcionalidades da nossa aplicação,
      recomendamos continuar no seu navegador preferido.
    </p>

    <div class="space-y-5">
      <a
        href="javascript:void(0);"
        (click)="openInExternalBrowser()"
        class="block w-full transform rounded-xl bg-orange-500 px-4 py-3.5 font-semibold text-white transition duration-300 hover:-translate-y-1 hover:bg-orange-600 hover:shadow-md focus:outline-hidden focus:ring-2 focus:ring-orange-500/50"
      >
        Continuar no navegador
      </a>

      <div
        class="flex items-center justify-center space-x-3 text-sm text-gray-400"
      >
        <div class="h-px w-16 bg-gray-200"></div>
        <span>ou</span>
        <div class="h-px w-16 bg-gray-200"></div>
      </div>

      <!-- Novo botão para copiar o link -->
      <a
        href="javascript:void(0);"
        (click)="copyLinkToClipboard()"
        class="block w-full transform rounded-xl border-2 border-orange-500 bg-white px-4 py-3 font-semibold text-orange-500 transition duration-300 hover:-translate-y-1 hover:bg-orange-50 hover:shadow-md focus:outline-hidden focus:ring-2 focus:ring-orange-500/50"
      >
        Copiar link para o navegador
      </a>

      <div
        class="flex items-center justify-center space-x-3 text-sm text-gray-400"
      >
        <div class="h-px w-16 bg-gray-200"></div>
        <span>opção manual</span>
        <div class="h-px w-16 bg-gray-200"></div>
      </div>

      <div class="rounded-xl bg-gray-50 p-4 text-sm text-gray-500">
        <p class="mb-3 font-medium">Você também pode:</p>
        <div class="mb-3 flex items-center space-x-3">
          <div class="mt-0.5 rounded-full bg-orange-100 p-1.5">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-4 w-4 text-orange-500"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M5 12h.01M12 12h.01M19 12h.01M6 12a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0z"
              ></path>
            </svg>
          </div>
          <div class="text-left">
            Tocar nos três pontos no canto superior direito
          </div>
        </div>
        <div class="flex items-center space-x-3">
          <div class="mt-0.5 rounded-full bg-orange-100 p-1.5">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-4 w-4 text-orange-500"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
              ></path>
            </svg>
          </div>
          <div class="text-left">Selecionar "Abrir no navegador"</div>
        </div>
      </div>
    </div>
  </div>

  <!-- Notificação de link copiado (inicialmente oculta) -->
  <div
    id="copyNotification"
    class="pointer-events-none fixed bottom-4 left-1/2 -translate-x-1/2 transform rounded-lg bg-gray-800 px-4 py-2 text-white opacity-0 transition-opacity duration-300"
  >
    Link copiado com sucesso!
  </div>
</div>
